import type { ReactNode } from "react"
import React from "react"

import { Box, Paper, Typography } from "@mui/material"

interface ReportSummaryProps {
  children: ReactNode
}

const DataSummary = ({ children }: ReportSummaryProps) => (
  <Box aria-labelledby="dataSummaryHeader" component="section">
    <Typography
      id="dataSummaryHeader"
      variant="h2"
      sx={{
        mb: 1,
      }}
    >
      Data Summary
    </Typography>
    <Paper sx={{ p: 2, width: "376px" }} variant="outlined">
      {children}
    </Paper>
  </Box>
)

export default DataSummary
